import axios from './axios'
import { CreateCustomerDto, CustomerDto, CustomerSearchResultDto, UpdateCustomerDto } from './types'

export const getCustomers = () => {
  return axios.get<CustomerSearchResultDto[]>('/customers')
}

export const searchCustomers = (query: string) => {
  return axios.get<CustomerSearchResultDto[]>('/customers/search', { params: { q: query } })
}

export const getCustomer = (id: string) => {
  return axios.get<CustomerDto>(`/customers/${id}`)
}

export const createCustomer = (data: CreateCustomerDto) => {
  return axios.post<CustomerDto>('/customers', data)
}

export const updateCustomer = (id: string, data: UpdateCustomerDto) => {
  return axios.put<CustomerDto>(`/customers/${id}`, data)
}
